import { Link } from '@/i18n/routing';
import Image from 'next/image';

interface Props {
  id: string;
  icon: string;
  name: string;
  barId: string;
  service: 'bar' | 'take_away';
  categoryId: string;
}

export default function CategoryItem({
  barId,
  service,
  categoryId,
  ...props
}: Props) {
  return (
    <Link
      className="no-underline"
      href={{
        pathname: '/bar/products',
        query: { barId, service, categoryId },
      }}
    >
      <li
        className="border border-greyscale-separator bg-greyscale-offwhite rounded-md flex items-center py-3 pl-1 pr-6 cursor-pointer h-full shadow-[0_0_35px_0_rgba(135,135,135,0.1)]"
        key={props.id}
      >
        <div className="w-10 h-10 mr-2 shrink-0">
          {props.icon && (
            <Image
              alt="Category icon"
              src={props.icon}
              layout="responsive"
              width={20}
              height={20}
            />
          )}
        </div>
        <div className="text-base text-greyscale-body">{props.name}</div>
      </li>
    </Link>
  );
}
